const styles = {
  headerSection: {
    position: "relative",
    top: "0",
    width: "100vw",
    height: "5em"
  },
  headerIcon: {
    padding: "1em",
    color: "rgb(106, 106, 120)",
    width: "74px",
    height: "74px"
  },
  body: {
    position: "relative",
    top: "0",
    width: "100vw",
    height: "100vh"
  },
  titleSection: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "5.125em"
  },
  actionsSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  title: {
    width: "640px",
    height: "57px",
    color: "rgb(29, 31, 32)",
    fontSize: "40px",
    fontFamily: "ToyotaType-Semibold",
    fontWeight: "600",
    textAlign: "center",
    letterSpacing: "-0.5px"
  },
  actions: {
    width: "17.25em",
    height: "3.75em",
    marginBottom: ".67em",
    background:
      "linear-gradient(-135deg, rgb(66, 129, 255) 0%, rgb(117, 117, 255) 100%)",
    borderRadius: 0,
    boxShadow: "none",
    fontFamily: "ToyotaType-Semibold",
    fontSize: "24px",
    fontWeight: "600",
    letterSpacing: "-0.5px"
  }
};

export default styles;
